<template>

	<router-view></router-view>

	<NotificationsViewer />

	<DebugBar />


	<EmergencyMenu :ref='_menus.user_menu'
		id='header_user_menu'
		:items='_user_actions'
		anchor-x='center' anchor-y='bottom'
		direction-x='center' direction-y='bottom'
		delta-y='-1rem'
		centered
		bigger-items
	/>

	<EmergencyMenu :ref='_menus.quick_menu'
		id='quick_menu'
		:items='_quick_actions'
		anchor-x='center' anchor-y='top'
		direction-x='center' direction-y='top'
		delta-y='-1rem'
		centered
		bigger-items
	/>

	<EmergencyMenu :ref='_menus.main_menu'
		id='main_menu'
		:items='_main_actions'
		anchor-x='center' anchor-y='top'
		direction-x='center' direction-y='top'
		delta-y='-1rem'
		centered
		bigger-items
	/>


	<EmergencySuccess :ref='_windows.log_out' chain='modal' @close='_Redirect' size='small' :timeout='10'>
		{{ txc( "You are now logged out", 'login' ) }}
	</EmergencySuccess>

</template>


<script setup>

	import { onMounted, provide, ref } from 'vue';
	import { useRouter } from 'vue-router/dist/vue-router';

	import { txc } from '@/modules/i18n';

	import * as User from '@/modules/user';

	import DebugBar from '@/debug/DebugBar';
	import NotificationsViewer from '@/_to_review/notifications/NotificationsViewer';

	import EmergencyMenu from '@/components/emergency/EmergencyMenu';
	import EmergencySuccess from '@/components/emergency/EmergencySuccess';

	//
	
	const _windows =
	{
		'log_out': ref()
	};

	const _menus =
	{
		'user_menu': ref(),
		'quick_menu': ref(),
		'main_menu': ref()
	};

	const _pickers =
	{
		// 'cleaning_assignee': ref()
	};
	
	const _confirmations =
	{
		// 'cleaning_free_room': ref(),
		// 'occupation_finalize_stay': ref()
	};
	
	provide( 'windows', _windows );
	provide( 'menus', _menus );
	provide( 'pickers', _pickers );
	provide( 'confirmations', _confirmations );

	//

	const router = useRouter();

	const _user_actions = ref( [] );
	const _quick_actions = ref( [] );
	const _main_actions = ref( [] );

	onMounted( () =>
	{
		_user_actions.value =
		[
			{
				label: "My profile",
				icon: '<i class="fa fa-user" />',
				action: () => Navigate_to( 'Profile', _menus.user_menu )
			},
			{
				label: "View my reservations",
				icon: '<i class="fa fa-parking" />',
				action: () => Navigate_to( 'Profile_reservations', _menus.user_menu )
			},
			{
				label: "View my packages",
				icon: '<i class="fa fa-boxes" />',
				action: () => Navigate_to( 'Profile_packages', _menus.user_menu )
			},
			{
				label: "View my contracts",
				icon: '<i class="fa fa-sheet-plastic" />',
				action: () => Navigate_to( 'Profile_contracts', _menus.user_menu )
			},
			{
				label: "View my vehicles",
				icon: '<i class="fa fa-car-side" />',
				action: () => Navigate_to( 'Profile_vehicles', _menus.user_menu )
			},
			{
				label: "Log out",
				icon: '<i class="fa fa-arrow-right-from-bracket" />',
				action: () => _Logout()
			}
		];

		_quick_actions.value =
		[
			{
				label: "View my reservations",
				icon: '<i class="fa fa-parking" />',
				action: () => Navigate_to( 'Profile_reservations', _menus.quick_menu )
			},
			{
				label: "View my packages",
				icon: '<i class="fa fa-boxes" />',
				action: () => Navigate_to( 'Profile_packages', _menus.quick_menu )
			},
			{
				label: "View my contracts",
				icon: '<i class="fa fa-sheet-plastic" />',
				action: () => Navigate_to( 'Profile_contracts', _menus.user_menu )
			}
		];

		_main_actions.value =
		[
			{
				label: "My profile",
				icon: '<i class="fa fa-user" />',
				action: () => Navigate_to( 'Profile', _menus.main_menu )
			},
			{
				label: "Log out",
				icon: '<i class="fa fa-arrow-right-from-bracket" />',
				action: () => _Logout()
			}
		];
	} );


	function _Logout ()
	{
		_windows.log_out.value.Open();
	}


	function _Redirect ()
	{
		User.Logout();

		router.push( { name: 'Login' } );
	}


	///


	function Navigate_to ( name, menu )
	{
		menu.value.Close();
		router.push( { name: name } );
	}

</script>


<style scoped>

	:global(#header_user_menu)
	{
		border-top: 0.15rem solid var(--theme-accent-lighter);
	}
	:global(#header_user_menu::before)
	{
		content: '';
		display: block;
		background: var(--theme-background);
		position: absolute;
		left: 50%;
		top: -0.15rem;
		width: 1rem;
		height: 1rem;
		transform-origin: center center;
		transform: translate(-50%, -50%) rotate(45deg);
		border: 0.15rem solid var(--theme-accent-lighter);
		border-right: none;
		border-bottom: none;
	}
	:global(#header_user_menu [er-window-content])
	{
		position: relative;
		z-index: 1;
	}


	:global(#quick_menu)
	{
		border-bottom: 0.15rem solid var(--theme-accent-lighter);
	}
	:global(#quick_menu::before)
	{
		content: '';
		display: block;
		background: var(--theme-background);
		position: absolute;
		left: 2rem;
		bottom: -1.15rem;
		width: 1rem;
		height: 1rem;
		transform-origin: center center;
		transform: translate(-50%, -50%) rotate(45deg);
		border: 0.15rem solid var(--theme-accent-lighter);
		border-left: none;
		border-top: none;
	}
	:global(#quick_menu [er-window-content])
	{
		position: relative;
		z-index: 1;
	}


	:global(#main_menu)
	{
		border-bottom: 0.15rem solid var(--theme-accent-lighter);
	}
	:global(#main_menu::before)
	{
		content: '';
		display: block;
		background: var(--theme-background);
		position: absolute;
		right: 1rem;
		bottom: -1.15rem;
		width: 1rem;
		height: 1rem;
		transform-origin: center center;
		transform: translate(-50%, -50%) rotate(45deg);
		border: 0.15rem solid var(--theme-accent-lighter);
		border-left: none;
		border-top: none;
	}
	:global(#main_menu [er-window-content])
	{
		position: relative;
		z-index: 1;
	}

</style>
